import { ModalLayer } from './modal-layer';
import { useModals } from '.';

export const ModalsRenderer = () => {
	const { modalData: layers, config } = useModals();

	return (
		<>
			{layers.map((layer, nth) => (
				<ModalLayer layer={nth + 1} key={`layer-${nth}`} data={layer} />
			))}
		</>
	)
}